'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAnalyticsCookie = getAnalyticsCookie;
exports.getAbCookie = getAbCookie;
exports.getKissmetricsCookie = getKissmetricsCookie;
exports.getCookieString = getCookieString;
exports.getAuthUserEmail = getAuthUserEmail;
exports.getKOALAEmailIdentity = getKOALAEmailIdentity;
exports.setAnalyticsCookie = setAnalyticsCookie;
exports.setKOALAEmailIdentity = setKOALAEmailIdentity;
exports.setCookie = setCookie;

var _jsCookie = require('js-cookie');

var Cookies = _interopRequireWildcard(_jsCookie);

var _cookieNames = require('../configs/cookieNames.js');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var multiValueCookieParser = Cookies.withConverter(function (value, name) {
    return _readMultipleValues(value);
});

function _readMultipleValues(value) {
    var cookieValues = {};
    value.split('&').forEach(function (part) {
        var _keyVal = part.split('=');
        cookieValues[_keyVal[0]] = _keyVal[1];
    });
    return cookieValues;
}

function getAnalyticsCookie() {
    var cookie = multiValueCookieParser.get(_cookieNames.COOKIE_NAMES.JG_ANALYTICS_COOKIE_NAME);
    return cookie ? cookie : {};
}

function getAbCookie() {
    var cookie = multiValueCookieParser.get(_cookieNames.COOKIE_NAMES.JG_ANALYTICS_AB);
    cookie = cookie ? cookie : {};
    return cookie.id;
}

function getKissmetricsCookie() {
    return Cookies.get(_cookieNames.COOKIE_NAMES.KM);
}

function getCookieString() {
    return Cookies.get();
}

function getAuthUserEmail(envCookieName) {
    var cookie = multiValueCookieParser.get(envCookieName);
    cookie = cookie ? cookie : {};
    return cookie.Email;
}

function getKOALAEmailIdentity() {
    return Cookies.get(_cookieNames.COOKIE_NAMES.KOALA_EmailIdentity);
}

function setAnalyticsCookie(logged_out_cookie, logged_in_cookie) {
    if (!logged_in_cookie) {
        logged_in_cookie = '00000000-0000-0000-0000-000000000000';
    };
    if (!logged_out_cookie) {
        logged_out_cookie = '00000000-0000-0000-0000-000000000000';
    };

    setCookie(_cookieNames.COOKIE_NAMES.JG_ANALYTICS_COOKIE_NAME, 'logged_in_guid=' + logged_in_cookie + '&logged_out_guid=' + logged_out_cookie); //Backward Compatibility
}

function setKOALAEmailIdentity(email) {
    setCookie(_cookieNames.COOKIE_NAMES.KOALA_EmailIdentity, email);
}

function setCookie(name, value) {
    Cookies.set(name, value, { expires: 3650 });
}


// WEBPACK FOOTER //
// ../~/@jg/koala-front-end-analytics/lib/lib/cookieBrowserApi.js